export const common = {
  'plsEnter': '请输入',
  'plsSelect': '请选择',
};

export default {
  kline: {
    '0m': '分时',
    '1m': '1分',
    '5m': '5分',
    '15m': '15分',
    '30m': '30分',
    '1h': '1小时',
    '1d': '1天',
    '1w': '1周',
  },
  depositStatus: {
    0: '待入帐',
    1: '充值成功',
    2: '到账失败',
  },
  withdrawStatus: {
    0: '审核中',
    1: '成功',
    2: '拒绝',
    3: '撤销',
    4: '审核通过',
    5: '打币中',
    6: '钱包异常，审核中',
  },
  map: {
    orderCategory: {
      1: '买入',
      2: '卖出',
    },
    orderType: {
      1: '限价',
      2: '市价',
    },
    myOrderStatus: {
      0: '待成交',
      1: '已成交',
      2: '取消',
    },
  },

  links: {
    announcement: 'https://grxtrade.s2.udesk.cn/hc/categories/20403?api_name=',
    fees: 'https://grxtrade.s2.udesk.cn/hc/sections/20629?api_name=',
    webGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20525?api_name=',
    appGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20613?api_name=',
  },

  'about.title': '关于GRXTrade',
  'about.desc': '全球币币交易费是以最低的收费并出现在最先进的数字资产交易所GRXTrade。一个平台上拥有这两个最好的功能。',
  'about.learnMore': '了解更多',

  'advanced.lvl2Verf': '等级2认证',
  'advanced.address.info': '居住地址',
  'advanced.address.proofOfAddress': '住址证明为官方或司法机关发出的文件，物业账单或银行文件，（必须全页显示及姓名必须与一级认证)',
  'advanced.address.building': '建筑号码',
  'advanced.address.street': '街',
  'advanced.address.district': '区域',
  'advanced.address.province': '省',
  'advanced.address.zipCode': '邮政号码',
  'advanced.address.city': '市',
  'advanced.address.authImgUrl1': '上传地址证明文件',
  'advanced.address.successSave': '居住地址已成功保存',

  'advanced.employment.info': '就业资料',
  'advanced.employment.proofOfIncomeDocuments': '收入证明为：工资单，银行月结单，报税单，融资合同 （必须全页显示及姓名必须与一级认证)',
  'advanced.employment.employStatus': '就业状态',
  'advanced.employment.sourceIncome': '收入来源',
  'advanced.employment.sourceIncomeName': '收入来源',
  'advanced.employment.industry': '行业',
  'advanced.employment.industryName': '行业',
  'advanced.employment.jobTitle': '职位',
  'advanced.employment.companyName': '公司名称',
  'advanced.employment.employerBuilding': '建筑号码',
  'advanced.employment.employerStreet': '街',
  'advanced.employment.employerZipCode': '邮政号码',
  'advanced.employment.employerCity': '市',
  'advanced.employment.employerDistrict': '区域',
  'advanced.employment.employerProvince': '省',
  'advanced.employment.authImgUrl2': '上传收入证明文件',
  'advanced.employment.successSave': '就业资料已成功保存',

  'affiliate.title': '会员计划',
  'affiliate.title.desc': '参与GRXTrade平台优质的会员计划，为您奉上最丰厚的利润回报',
  'affiliate.actions.joinNow': '立即加入',
  'affiliate.desc.1': 'GRXTrade平台方旨在通过其推出的会员计划，使您的交易增长潜力和盈利能力最大化。',
  'affiliate.desc.2': '每个人都可以加入我们的会员计划！此计划利润丰厚，立即加入开始赚钱吧。交易者将获得最低20%、累计最高40%的交易手续费佣金。收益远远不止于此。只要您推荐的会员附保持一定的活跃度，您将可以持续获得佣金。',
  'affiliate.desc.3': '市场上大多数同行业者仅在有限的时间内提供类似的福利，但是，GRXTrade平台的员计划将无限期为我们的用户带来高额收益。',
  'affiliate.desc.4': '还在犹豫什么？立即加入GRXTrade会员计划，拓展您的交易潜力与交易深度吧。',
  'affiliate.whyJoin.title': '为什么要加入会员计划？',
  'affiliate.whyJoin.desc.1': '市场最佳佣金率和奖金福利',
  'affiliate.whyJoin.desc.2': '顶级会员可享受专属特权并获得第一手资讯',
  'affiliate.whyJoin.desc.3': '专属客户经理，支持您的业务拓展',
  'affiliate.whyJoin.desc.4': '通过我们精心设计的会员计划，为您拓展潜在市场',
  'affiliate.works.title': '会员计划的具体规则',
  'affiliate.works.desc': 'GRXTrade不仅是一个为全球用户提供金融级数字资产交易和资产管理服务的数字资产交易所，其同时可提供相应的增值方案，投资者通过会员计划获得可持续性的收益',
  'affiliate.sharing.title': '会员计划分润体系',
  'affiliate.sharing.normal.title': '普通会员',
  'affiliate.sharing.senior.title': '高级会员',
  'affiliate.sharing.top.title': '顶级会员',
  'affiliate.sharing.joining.fee': '免费',
  'affiliate.sharing.commission.20': '享有旗下直接用户交易手续费的20%',
  'affiliate.sharing.commission.20.senior': '享有旗下直接用户交易手续费的20%',
  'affiliate.sharing.fee.200': '费用:200 USDT/年',
  'affiliate.sharing.commission.1st.level': '享有旗下间接用户交易手续费的10%',
  'affiliate.sharing.fee.rebate': '享有手续费折扣300USDT',
  'affiliate.sharing.fee.rebate2': '享有手续费折扣200USDT',
  'affiliate.sharing.fee.300': '费用:300 USDT/年',
  'affiliate.sharing.commission.2nd.level': '享有旗下二级间接用户交易手续费的10%',
  'affiliate.sharing.wdec2': '享有WDEC（教育网站）价值1980USDT的实战培训课程，且享有指定商学院免费的线下学习机会。',
  'affiliate.sharing.wdec': '享有WDEC（教育网站）价值2980USDT的实战培训课程，且享有指定商学院免费的线下学习机会。',
  'affiliateInvite.joinAffiliateModal.affiliateLevel': '会员级别：',
  'affiliateInvite.joinAffiliateModal.fee': '培训费：',
  'affiliateInvite.joinAffiliateModal.termsAndCondition': '在此点击此按钮，即表示您同意会员计划的<a href="/legal/affiliate-policy" target="_blank" style="color: #1E49AC">条款与条件</a>',
  'affiliateInvite.joinAffiliateModal.balance': '我的资产余额：',
  'affiliateInvite.joinAffiliateModal.mustCheckText': '您必须同意条款和条件才能继续进行',

  'actions.back': '返回',
  'actions.cancel': '取消',
  'actions.contactUs': '联络我们',
  'actions.close': '关闭',
  'actions.copy': '复制',
  'actions.confirm': '确定',
  'actions.delete': '删除',
  'actions.download': '下载',
  'actions.login': '登录',
  'actions.loginNow': '立即登录',
  'actions.loginMaxWallet': '使用MAX-Wallet登录',
  'actions.registMaxWallet': '使用MAX-Wallet注册',
  'actions.registNow': '立即注册',
  'actions.register': '注册',
  'actions.save': '保存',
  'actions.sendEmailOtp': '发送邮箱验证码',
  'actions.sendOtp': '发送验证码',
  'actions.submit': '提交',
  'actions.tradeCancel': '撤销',
  'actions.tradeCancelAll': '撤销全部',
  'actions.deposit': '充币',
  'actions.withdraw': '提币',
  'actions.setup': '设置',
  'actions.modify': '修改',
  'actions.search': '搜索',

  'common.selectCountry': '选择国家',
  'common.noRecords': '暂无数据',
  'common.recordsPerPage': '每页的记录',

  'company.profile.title': '公司简介',
  'company.profile.desc.1': '2017年提出的想法最终在两年后得以实现。GRXTrade是新一代数字资产交易服务平台。',
  'company.profile.desc.2': '我们的愿景是通过创建一个面向行业4.0的加密金融中心来塑造未来的全球经济，该中心专注于提供多种交易选项的区块链技术，全天候个人客户支持服务以及卓越的平台安全功能。',
  'company.profile.vision': '愿景',
  'company.profile.vision.desc.1': '目前，市场上充斥着大量的加密交易平台可供交易者选择，但有时又难以挑选到最优的交易平台。值得注意的是，过多交易平台的存在将带来流动性低的问题。其中许多交易所仅在特定国家运营，更糟糕的是，其中一些交易平台还可能存在欺诈性质。',
  'company.profile.vision.desc.2': 'GRXTrade计划凭借最优的市场交易费用和最受欢迎的交易对来服务于国际市场交易者，从而提升交易所的运作水平。本交易所平台将与Oneness生态系统通证(即OEP通证)相融合，通过与其他交易所网络共享流动性，消除低流动性所带来的风险。',
  'company.profile.features': '特点',
  'company.profile.features.subheader': '是什么让GRXTrade成为独特的加密交易平台？',
  'company.profile.features.title.1': 'Security',
  'company.profile.features.title.2': 'Lowest Trading Fees',
  'company.profile.features.title.3': '会员项目',
  'company.profile.features.title.4': '智能交易者',
  'company.profile.features.desc.1': 'GRXTrade由全球怀有共同理念和追求共同愿景的技术领域企业家所创立，该愿景即旨在提供基于区块链技术的金融科技产品，以创造更多具有包容性的且受道德约束的金融准入机。',
  'company.profile.features.desc.2': '自2017年成立以来，GRXTrade始终致力于通过不断开拓创新的方式，凭借全面、智能化的金融工具将金融科技与传统金融相结合，打造未来的全球数字经济模式，造福大众的日常生活。',
  'company.profile.features.desc.3': 'GRXTrade创始团队主要来自金融和IT行业，所有成员均为在各自行业拥有15年以上经验的资深人士，此前主要担任外汇、金融行业、加密交易和信息技术行业顾问。GRXTrade的综合管理和技术团队是分散化的，同时，我们的业务遍及中国、中国台湾、新加坡、韩国、日本和阿拉伯联合酋长国的多个主要城市。',
  'company.profile.features.desc.4': '本团队很早便衍生出开发加密交易平台的想法，根据我们的计划，该平台将不同于仅提供标准产品功能与服务的普通交易平台。终于，经过短短不到三年的时间，GRXTrade即将作为一个符合欧洲国家法规监管的、远超越普通数字资产交易平台的创新型平台，于2020年第一季度正式面市。',
  'company.profile.last.word': '即刻加入GRXTrade 为您的未来投资',

  'contactUs.title': '联络我们',
  'contactUs.desc.1': '如需更多咨询，您可以向我们发送电子邮件至',
  'contactUs.desc.2': '我们将在24小时内回复所有查询。 万一有任何延迟的方面，我们非常感谢您的理解和支持。',
  'contactUs.desc.3': '贵客请放心，我们的客户支持团队经过了专业培训，能够处理客户的任何疑虑。',

  'dealProfessional.kLine.text': 'K线',
  'dealProfessional.depth.text': '深度图',
  'dealProfessional.original.text': '原版k线',
  'dealProfessional.buyEntrust': '买盘委托',
  'dealProfessional.sellEntrust': '卖盘委托',
  'dealProfessional.price': '价格',
  'dealProfessional.sum': '累计',

  'fee.title': '交易费用结构',
  'fee.desc.1': '我们提供镇上',
  'fee.lowest': '最低',
  'fee.desc.2': '的交易费.',
  'fee.desc.3': '选择GRXTrade来进行交易，以增长您的盈利能力和回报。',
  'fee.reference.text': '下表是我们的交易费用结构，仅供参考。',
  'fee.vip.level.title': 'VIP 等级',
  'fee.trade.volume.title': '30天交易量 (USDT)',
  'fee.all.zone.title': '全区',
  'fee.maker.title': '制作者',
  'fee.taker.title': '接收者',
  'fee.vip.normal': '普通',
  'fee.vip.level.1': '第一级',
  'fee.vip.level.2': '第二级',
  'fee.vip.level.3': '第三级',
  'fee.vip.level.4': '第四级',
  'fee.vip.level.5': '第五级',
  'fee.volume.1.million': '0 ≤ 100万的体积',
  'fee.volume.5.million': '100万 ≤ 体积 ≤ 500万',
  'fee.volume.35.million': '500万 ≤ 体积 ≤ 3500万',
  'fee.volume.100.million': '3500万 ≤ 体积 ≤ 1亿',
  'fee.volume.300.million': '1亿 ≤ 体积 ≤ 3亿',
  // 'fee.volume.over.300.million': '≥ 3亿',
  // 'fee.withrawal.title': 'Withdraw Fee',
  // 'fee.withrawal.asset.type': 'Asset Type',
  // 'fee.withrawal.withdrawal.fees': 'Withdrawal Fees',
  // 'fee.withrawal.min.withdraw': 'Minimum Withdrawal',
  // 'fee.withrawal.term.1': '* The transaction fee will be deducted from your total transaction amount.',
  // 'fee.withrawal.term.2': '* Fees are regularly adjusted according to market conditions. ',
  // 'fee.withrawal.term.3': '* All the information given above is up-dated.',

  'footer.aboutGrx': '关于 GRXTrade',
  'footer.aboutGrx.aboutUs': '关于我们',
  'footer.aboutGrx.contactUs': '联系我们',
  'footer.aboutGrx.companyProfile': '公司背景',
  'footer.aboutGrx.affProgram': ' 会员计划',
  'footer.aboutGrx.fees': '费率',
  'footer.aboutGrx.teamProfile': '公司管理层',
  'footer.aboutGrx.helpCenter': '帮助中心',
  'footer.aboutGrx.helpCenter.web': '电脑版',
  'footer.aboutGrx.helpCenter.app': '手机版',

  'footer.legal': '法律',
  'footer.legal.termsOfUse': '使用条款',
  'footer.legal.amlPolicy': '反洗钱与打击资助恐怖主义政策',
  'footer.legal.riskStatement': '风险披露声明',
  'footer.legal.privacyPolicy': '隐私政策',
  'footer.legal.affiliatePolicy': '会员政策',
  'footer.legal.partnerPolicy': '合伙人政策',

  'header.assets': '资产',
  'header.downloadApp': '下载App',
  'header.exchange': '币币交易',
  'header.login': '登录',
  'header.markets': '行情',
  'header.register': '注册',
  'header.orders': '订单',
  'header.announcement': '公告中心',
  'header.helpCenter': '帮助中心',

  'header.user.drop.verification': '身份认证',
  'header.user.drop.fee.setting': '费率设置',
  'header.user.drop.invite': '邀请好友',
  'header.user.drop.member.level': '会员等级',
  'header.user.drop.vip.level': 'VIP',
  'header.user.drop.30d.vol': '30天量',
  'header.user.drop.logout': '退出',

  'labels.actions': '操作',
  'labels.reminder': '温馨提示',
  'labels.confirmation': '确认',
  'labels.confirmPwd': '确认密码',
  'labels.date': '时间',
  'labels.joinDate': '加入时间',
  'labels.cdate': '创建时间',
  'labels.mdate': '更新时间',
  'labels.email': '邮箱',
  'labels.emailOtp': '邮箱验证码',
  'labels.mobileNo': '手机号码',
  'labels.ga': '谷歌验证',
  'labels.gaCode': '谷歌验证码',
  'labels.unbind': '重新绑定',
  'labels.orderId': '订单ID',
  'labels.tradeId': '交易ID',
  'labels.pwd': '密码',
  'labels.setup': '设置',
  'labels.view': '查看',
  'labels.txnPwd': '交易密码',
  'labels.loading': '加载',
  'labels.language': '语言',
  'labels.add': '添加',
  'labels.uid': 'UID',
  'labels.reset': '重置',
  'labels.maxRegister': '授权MAX-Wallet登录',

  'labels.transaction.assetType': '资产类型',
  'labels.transaction.from': '时间开始',
  'labels.transaction.to': '时间结束',
  'labels.transaction.time': '时间',
  'labels.transaction.coin': '币种',
  'labels.transaction.id': 'ID',
  'labels.transaction.type': '类别',
  'labels.transaction.total': '总数',
  'labels.transaction.freeze': '冻结',
  'labels.transaction.remark': '备注',
  'labels.transaction.freezeamount': '冻结数量',
  'labels.transaction.availablebalance': '可用数量',
  'labels.transaction.freezeAsset': '冻结资产',
  'labels.transaction.availableAsset': '可用资产',
  'labels.transaction.beforeAmount': '金额前',
  'labels.transaction.changeAmount': '改换金额',
  'labels.transaction.afterAmount': '金额后',
  'labels.transaction.fee': '费用',
  'labels.transaction.today': 'Today',
  'labels.transaction.sevenday': '7 day',
  'labels.transaction.fifteen': '15 day',
  'labels.transaction.thirty': '30 day',
  'labels.transaction.all': 'All',
  'labels.transaction.search': '搜索',

  'labels.trade.market': '市场',
  'labels.trade.coinOrders': '订单管理',
  'labels.trade.buy': '买入',
  'labels.trade.sell': '卖出',
  'labels.trade.pair': '交易对',
  'labels.trade.side': '方向',
  'labels.trade.type': '方式',
  'labels.trade.amt': '交易额',
  'labels.trade.dealAmt': '成交额',
  'labels.trade.dealVol': '成交量',
  'labels.trade.history.vol': '成交量',
  'labels.trade.vol': '数量',
  'labels.trade.price': '价格',
  'labels.trade.orderVol': '委托数量',
  'labels.trade.orderPrice': '当前',
  'labels.trade.avgPrice': '历史委托中',
  'labels.trade.change': '涨幅',
  'labels.trade.24change': '24H涨幅',
  'labels.trade.24high': '24H高',
  'labels.trade.24low': '24H低',
  'labels.trade.24vol': '24H量',
  'labels.trade.limit': '限价交易',
  'labels.trade.tradeHistory': '实时成交',
  'labels.trade.time': '时间',
  'labels.trade.latestPrice': '最新价',
  'labels.trade.startTrade': '开始交易',
  'labels.trade.add.sessionTxnPwd': '记住交易密码',
  'labels.trade.depth': '深度',

  'labels.reward.title': '剩余奖励会员数',
  'labels.reward.human': '人',
  'labels.reward.10.mxw': '立即获取您的10MXW！',
  'labels.reward.tnc': '满足条件:',
  'labels.reward.tnc.1': '1。用户注册和完成实名认证',
  'labels.reward.tnc.2': '2。至少有1个邀请',

  'labels.status': '状态',
  'labels.openOrders': '当前委托',
  'labels.or': '或',
  'labels.orderHistory': '历史委托',
  'labels.orders': '订单',
  'labels.otp': '验证码',
  'labels.remarks': '备注',

  'labels.scanQrCode': '请扫描MAX-Wallet应用程序中的二维码开始认证',
  'labels.wechatQrCode': '官方客服群',

  'labels.finance.coinToCoinAcc': '财务管理',
  'labels.finance.coin': '币种',
  'labels.finance.available': '可用',
  'labels.finance.freeze': '冻结',
  'labels.finance.total': '总数',
  'labels.finance.records': '财务记录',
  'labels.finance.transaction': '账户报表',
  'labels.finance.addrMgmt': '提币地址管理',
  'labels.finance.walletAddr': '地址',
  'labels.finance.depositAddr': '充值地址',
  'labels.finance.withdrawalAddr': '提币地址',
  'labels.finance.memo': '地址标签',
  'labels.finance.memo.notes': '（填写错误可能导致资产损失，请仔细核对）',
  'labels.finance.depositRecords': '充币记录',
  'labels.finance.withdrawRecords': '提币记录',
  'labels.finance.actualAmt': '到账数量',
  'labels.finance.qty': '数量',
  'labels.finance.fee': '手续费',
  'labels.finance.recharge.tips': '地址标签和充币地址同时正确填写才能充值到G平台，遗漏地址标签将导致资金丢失！',
  'labels.finance.withdraw.riskWarning': '风险提示',
  'labels.finance.withdraw.riskWarning.desc.1': '您的提币操作一旦完成，对应的资产所有权将由您变更为目标地址所对应的账户所有人享有。',
  'labels.finance.withdraw.riskWarning.desc.2': '请您务必在提币操作前，仔细核对提币地址信息，确保提币属于自愿行为，并确认不涉及任何传销、非法集资、诈骗等违法情形，谨防上当受骗，避免造成不必要的财产损失。',

  'labels.acc.inviteFriend': '邀请好友',
  'labels.acc.upgradeToPartner': '升级合伙人',
  'labels.acc.feeLevel': '费率等级',
  'labels.acc.kyc': '实名认证',
  'labels.acc.advKyc': '高级认证',
  'labels.acc.pass': '已通过',
  'labels.acc.notPass': '立即认证',
  'labels.acc.securitySettings': '安全设置',
  'labels.acc.bindEmail': '绑定邮箱',
  'labels.acc.bindEmail.desc': '获取每周最新的技术分析，新闻和促销活动。',
  'labels.acc.ga.desc': '资产提现、修改密码及安全设置时需要输入谷歌验证码。',
  'labels.acc.ga.desc2': '谷歌身份验证器是一款动态口令工具，工作原理类似短信动态验证。绑定后每30s生成一个动态验证码，验证码可用于登录、提现、修改安全设置等操 作的安全验证。',
  'labels.acc.ga.desc3': '使用谷歌验证器扫描下图维码',
  'labels.acc.ga.desc4': '如果您无法扫描二维码，可以将以下16位密钥手动输入到谷歌验证APP中',
  'labels.acc.ga.desc5': '密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将下述密钥备份保存',
  'labels.acc.ga.setupSuccess': '谷歌验证已成功设置',
  'labels.acc.ga.step1': '下载并安装谷歌验证器APP',
  'labels.acc.ga.step2': '扫描二维码',
  'labels.acc.ga.secret': '秘钥',
  'labels.acc.ga.device': '设备名称',
  'labels.acc.notBind': '未绑定',
  'labels.acc.bind': '已绑定',
  'labels.acc.loginPwd': '登录密码',
  'labels.acc.loginPwd.desc': '用于系统登录，为了您的资产安全，登录密码修改后24H以内不允许提币或场外交易。',
  'labels.acc.loginPwd.set': '设置登录密码',
  'labels.acc.loginPwd.update': '修改登录密码',
  'labels.acc.loginPwd.oldPwd': '旧登录密码',
  'labels.acc.loginPwd.newPwd': '新登录密码',
  'labels.acc.loginPwd.confirmNewPwd': '确认新登录密码',
  'labels.acc.loginPwd.confirmPwd': '确认登录密码',
  'labels.acc.loginPwd.googleValid': '谷歌验证',
  'labels.acc.ga.txt.1': '系统检测到您还未设置谷歌验证，请先',
  'labels.acc.ga.setup': '设置谷歌验证！',
  'labels.acc.idVerf': '身份认证',
  'labels.acc.idVerf.rejected': '已被拒绝',
  'labels.acc.idVerf.verified': '已认证',
  'labels.acc.idVerf.pending': '等待审批',
  'labels.acc.idVerf.plsCompLvl1': '先完成等级1认证',
  'labels.acc.idVerf.verifyNow': '去认证',
  'labels.acc.idVerf.maxRegist': '使用MAX-Wallet认证',
  'labels.acc.idVerf.lvl1': '等级1',
  'labels.acc.idVerf.lvl1.desc': '身份或护照证明及活体认证。',
  'labels.acc.idVerf.lvl2': '等级2',
  'labels.acc.idVerf.lvl2.desc': '高级认证',
  'labels.acc.txnPwd': '交易密码',
  'labels.acc.confirmTxnPwd': '确认交易密码',
  'labels.acc.txnPwd.desc': '账户资金变动时，需先验证交易密码。',
  'labels.acc.txnPwd.desc2': '用于登录、交易、内部转账、提币，账户资金变动时，先验证交易密码。',
  'labels.acc.txnPwd.setup': '设置交易密码',
  'labels.acc.txnPwd.modify': '修改交易密码',
  'labels.acc.txnPwd.old': '旧交易密码',
  'labels.acc.txnPwd.new': '新交易密码',
  'labels.acc.txnPwd.confirmNew': '确认新交易密码',
  'labels.acc.mobile.verf': '手机验证',
  'labels.acc.bindNow': '立即绑定',
  'labels.acc.unbindNow': '解除绑定',
  'labels.acc.notSetup': '未设置',
  'labels.acc.setup': '已设置',
  'labels.acc.side.accMsgs': '账户信息',
  'labels.acc.side.accMgmt': '帐号管理',
  'labels.acc.side.mobileVerf': '手机验证',
  'labels.acc.side.idVerf': '身份认证',
  'labels.acc.side.userCenter': '个人中心',
  'labels.acc.side.loginRecord': '登录记录',
  'labels.acc.invite.desc1': '邀请好友注册GRXTrade，轻松获得交易手续费和年费返佣',
  'labels.acc.invite.desc2': '轻松获得好友手续费20%返佣福利、会员年费20%返佣福利',
  'labels.acc.invite.step1.desc1': '发送邀请给好友',
  'labels.acc.invite.step1.desc2': '通过分享链接/二维码/邀请码注册GRXTrade',
  'labels.acc.invite.step2.desc1': '好友注册',
  'labels.acc.invite.step2.desc2': '好友接受邀请完成注册并进行币币交易',
  'labels.acc.invite.step3.desc1': '获得相应比例返佣',
  'labels.acc.invite.step3.desc2': '轻松获得好友交易手续费返佣和年费会员返佣',
  'labels.acc.invite.enterCode': '输入邀请码',
  'labels.acc.invite.inexchangabledesc': '在完成邀请新用户注册后，用户本身的推荐码将不能更改',
  'labels.acc.invite.code': '邀请码',
  'labels.acc.invite.qrCode': '二维码',
  'labels.acc.invite.download.qrCode': '下载二维码',
  'labels.acc.invite.mySharing': '我的专属分享方式',
  'labels.acc.invite.registerLink': '注册链接',
  'labels.acc.invite.registerTotal': '邀请总人数',
  'labels.acc.invite.kycTotal': '实名认证人数',
  'labels.acc.invite.activityDetail': '活动细则',
  'labels.acc.invite.downlineAcc': '被邀请人账号',
  'labels.acc.invite.noReferral': `没有邀请人?`,
  'labels.acc.invite.noReferral.confirm': `您确定您没有邀请人添加?`,
  'labels.acc.invite.history': '邀请记录',
  'labels.acc.inboxMsg.notification': '通告',
  'labels.acc.inboxMsg.readMsg': '已读消息',
  'labels.acc.inboxMsg.unreadMsg': '未读消息',
  'labels.acc.inboxMsg.title': '标题',
  'labels.acc.inboxMsg.deleteMsg.title': '删除消息',
  'labels.acc.inboxMsg.deleteMsg.desc': '确定删除消息?',
  'labels.acc.maxRegister': '授权MAX-Wallet登录',
  'labels.acc.side.maxRegister': '授权MAX-Wallet登录',
  'labels.acc.maxRegister.desc': '',
  'labels.acc.maxRegister.setupSuccess': '你已经成功绑定MAX-Wallet',
  'labels.acc.loginRecord.tag1': '登录历史',
  'labels.acc.loginRecord.tag2': '安全设置历史',
  'labels.acc.loginRecord.loginIp': 'IP地址',
  'labels.acc.loginRecord.security': '安全设定',
  'labels.acc.partnership': '合伙人计划',
  'labels.acc.partnership.desc': 'Please ask word to display',
  'labels.acc.partnership.pendingUpgrade': '等待升级{title}',
  'labels.acc.partnership.expiredUpgrade': '已到期日',

  'landing.market.title': '一切币币交易在你手中',
  'landing.market.viewMore': '查看更多',
  'landing.exp.title': '体验一站式数字资产交易平台',
  'landing.exp.title.desc': 'GRXTrade是以用户为中心的最新数字资产交易平台，提供市场上极具竞争力的交易费用。让用户在平台里享有最佳利益。',
  'landing.exp.sec.1': '为所有数字资产交易需求的一站式解决方案中心',
  'landing.exp.sec.2': '市场上最低的交易手续费',
  'landing.exp.sec.3': '全面会员计划',
  'landing.exp.sec.4': '优质的平台安全功能',
  'landing.exp.sec.5': '客户支持服务',
  'landing.exp.desc.1': '提供多种交易选项和最受欢迎的交易对',
  'landing.exp.desc.2': '高竞争力的交易手续费，低至0.04％',
  'landing.exp.desc.3': '通过活跃推荐者获取40％的被动佣金收入',
  'landing.exp.desc.4': '与CipherTrace®和MAX-Wallet系统整合',
  'landing.exp.desc.5': '提供快速响应时间的高效客户服务',
  'landing.exp.whyG.1': '计划凭借最优的市场交易费用和最受欢迎的交易对来服务于国际市场交易者，从而提升交易所的运作水平。本交易所平台将通过与其他交易所网络共享流动性，消除低流动性所带来的风险。',
  'landing.exp.whyG.2': '无论你是高级交易者还是交易新手，GRXTrade都将赋予您打造专属金融交易路线的能力。我们的交易所提供越来越多的密码货币交易对供您投资，还将为您带来一系列工具和功能，以丰富您的投资组合。',
  'landing.exp.whyG.3': 'GRXTrade是以用户为主的平台。在这个行业中，我们了解安全性对用户的重要。为了加强保护，我们与强大的合作伙伴合作，以增加信任度和安全性。',
  'landing.exp.whyG.subtitle1.desc': '您可以安全控制您的数字资产。 GRXTrade运用了MAX-Wallet的科技。这是一种在于Maxonrow区块链构建的移动应用程序，其以创新的实名KYC和AML兼容机制而闻名。',
  'landing.exp.whyG.subtitle2.desc': 'CipherTrace是由经验丰富的硅谷企业家领先创立以及数字资产情报为主，以实现蓬勃发展的区块链的经济。它旨在开发数字资产和区块链跟踪和安全功能为主。',
  'landing.exp.whyG.4': '现在就加入GRXTrade，为您的未来投资。',
  'landing.getStarted.title': '开始免费使用GRXTrade App吧',
  'landing.getStarted.desc': '使用我们的Android和iOS应用程序与最新的图表和市场保持联系，或者您可以使用我们的Mac或Windows专业交易应用程序从台式机进行交易。',
  'landing.getStarted.sec.1': '管理您喜欢的市场',
  'landing.getStarted.sec.2': '安全认证',
  'landing.getStarted.sec.3': '币币交易',
  'landing.getStarted.desc.1': '所有数字资产交换功能都在您的掌中。',
  'landing.getStarted.desc.2': '多重身份认证，KYC机制，登录安全保护，钱包定期维护。',
  'landing.getStarted.desc.3': '我们的高流动性交换可确保您的交易订单以所需的价格快速执行。',
  // 'landing.think.title': '还需要考虑？',
  'landing.think.title.desc': '开始探索GRXTrade平台的额外功能',
  'landing.think.sec.1': '会员计划',
  'landing.think.sec.1.coming': '（敬请期待）',
  'landing.think.sec.2': '手续费',
  'landing.think.desc.1': '立即了解有关我们会员计划的更多信息',
  'landing.think.desc.2': '熟悉我们的交易手续费结构',
  'landing.partner.title': '合作伙伴',
  'landing.partner.cipher.text': '领先的区块链安全合规品牌，保障您的交易安全与合规性',
  'landing.partner.wallet.text': 'CipherTrace®，可信赖的区块链安全企业，增进数字资产经济的信任与安全',
  'landing.partner.wallet.link': 'MAX-Wallet',

  'login.welcome': '欢迎登录',
  'login.forgotPwd': '忘记密码',
  'login.loggingIn': '登录中',
  'login.registerForFree': '免费注册',
  'login.dontHaveAcc': '还没有账户？',
  'login.success': '您已成功登录',

  'market.list.table.header.pair': '市场',
  'market.list.table.header.lastPrice': '最新成交价',
  'market.list.table.header.24HChange': '今日涨跌',
  'market.list.table.header.24HHigh': '24H最高价',
  'market.list.table.header.24HLow': '24H最低价',
  'market.list.table.header.24HVol': '24H成交量',

  'max.register.title.login': 'MAX-Wallet登录',
  'max.register.title.registration': 'MAX-Wallet注册',
  'max.register.title.kyc': '实名认证(MAX-Wallet)',
  'max.register.title.bind': '授权MAX-Wallet登录',
  'max.register.desc.login': '使用MAX-Wallet登录或在此下载',
  'max.register.desc.bind': '授权MAX-Wallet登录或在此下载',
  'max.register.desc.registration': '使用MAX-Wallet注册或在此下载',
  'max.register.desc.kyc': '若继续，MAX-Wallet将与grxtrade.com分享您的个人信息。',
  'max.register.subDesc.kyc': `在使用此应用之前，请您阅读我们的<a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">使用条款</a>。`,
  'max.register.question': '有疑问? 请到访我们的',
  'max.register.helpCenter': '帮助中心',
  'max.register.iAgree': '我同意给予GRXTrade实名认证的资料',
  'max.register.step1': '打开 MAX-Wallet',
  'max.register.step2': '在顶部菜单上',
  'max.register.step3': '将相机对准上方的二维码',

  'promoMaxRegModal.title': '欢迎体验简易注册',
  'promoMaxRegModal.desc': '为了方便您快速登录GRXTrade，我们建议您用MAX-Wallet进行注册。',
  'promoMaxRegModal.explain': 'MAX-Wallet*用户可在GRXTrade享受:',
  'promoMaxRegModal.benefit1': '一键注册',
  'promoMaxRegModal.benefit2': '一键登录',
  'promoMaxRegModal.benefit3': '即时KYC审核通过',
  'promoMaxRegModal.benefit4': '减少重复繁杂的认证提交和登入程序',
  'promoMaxRegModal.benefit5': '可享有持续开发的新功能对接',
  'promoMaxRegModal.benefit6': '* 须更新最新版本MAX-Wallet',
  'promoMaxRegModal.unableDownload': '无法下载应用程序?',
  'promoMaxRegModal.downloadLink': `<span style="font-size: 14px">请尝试<a href="{ios}" target="_blank" style="color: #1E49AC">下载iOS系统IPA格式文件</a>或<a href="{android}" target="_blank" style="color: #1E49AC">安卓系统APK格式文件</a></span>`,
  'promoMaxRegModal.downloadNow': '下载MAX-Wallet',
  'promoMaxRegModal.registerPage': `返回邮箱注册`,
  'promoMaxRegModal.continueWithMaxWallet': '使用MAX-Wallet',
  'promoMaxRegModal.here': '这里',

  'maxRegisterModal.title': '使用MAX-Wallet註冊',
  'maxRegisterModal.desc': '如果您已在MAX-Wallet完成实名认证(KYC)，您可选择用MAX-Wallet注册并在GRXTrade完成即时实名认证。',
  'maxRegisterModal.scanQrCode': '请用MAX-Wallet扫描以下的二维码开始注册',
  'maxRegisterModal.agreeAndContinue': '同意KYC注册',
  'maxRegisterModal.registerWithoutKyc': '注册但不提交KYC',

  'register.registration': '欢迎注册',
  'register.registration.select': '请先选择，进入下一步。',
  'register.registration.withEmail': '此设备没有安装MAX-Wallet',
  'register.registration.withMaxWallet': '此设备已经安装MAX-Wallet',
  'register.inviteCode': '邀请码（选填）',
  'register.alreadyRegist': '已有账户？',
  'register.termAndUsePrivacyPolicy': `创建帐户，即表示我同意GRXTrade的<a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">使用条款</a>和<a href="/legal/privacy-policy" target="_blank" style="color: #1E49AC">隐私政策</a>。`,
  'register.success': '恭喜您，注册成功！',

  'trade.buy.success': '交易成功',
  'trade.sell.success': '交易成功',
  'trade.cancel.confirm': '您确定要撤销此订单？',
  'trade.cancel.success': '订单撤销成功！',
  'trade.match.success': '订单已经匹配! {number}',

  'v.r.advance.address.building': '建筑号码不能为空',
  'v.r.advance.address.street': '街不能为空',
  'v.r.advance.address.district': '区域不能为空',
  'v.r.advance.address.province': '省不能为空',
  'v.r.advance.address.zipCode': '邮政号码不能为空',
  'v.r.advance.address.city': '市不能为空',
  'v.r.advance.address.countryCode': '国家不能为空',
  'v.r.advance.address.authImgUrl1': '地址证明文件不能为空',
  'v.advance.submit.success': '高级认证提交成功',
  'v.advance.submit.error': '请先保存居住地址和就业资料',

  'v.common.pwd.required': common.plsEnter + '密码',
  'v.common.pwd.pwdValid': '密码格式错误，密码长度必须在6-20位之间并包含大写字母+小写字母+数字',
  'v.common.pwd.pwdValid.note': '密码长度必须在6-20位之间并包含大写字母+小写字母+数字',
  'v.common.oldPwd.required': common.plsEnter + '旧密码',
  'v.common.newPwd.required': common.plsEnter + '新密码',
  'v.common.secondPwd.required': '请再次输入密码',
  'v.common.secondPwd.sameAs': '两次密码输入不一致',
  'v.common.txnPwd.required': common.plsEnter + '交易密码',
  'v.common.txnPwd.format': '密码格式错误，密码长度必须在6-20位之间并包含大写字母+小写字母+数字',
  'v.common.txnPwd.format.note': '密码长度必须在6-20位之间并包含大写字母+小写字母+数字',
  'v.common.txnPwd.notsame': '新交易密码不能与旧交易密码一致',
  'v.common.txnPwd.retype': '请再次输入交易密码',
  'v.common.payPwd.wrong': '密码格式错误，密码长度必须等∂于6',
  'v.common.email.required': common.plsEnter + '邮箱',
  'v.common.email.format': '请输入正确的邮箱地址',
  'v.common.otp.required': common.plsEnter + '验证码',
  'v.common.otp.verifyCode': '请输入正确的邮箱验证码',
  'v.common.country.required': common.plsSelect + '国家',
  'v.common.gaCode.required': common.plsEnter + '谷歌验证码',
  'v.common.gaCode.format': '请输入正确的谷歌验证码',
  'v.common.invite': '请填写邀请码',
  'v.common.kyc': '请先完成实名认证',
  'v.common.cannot.blank': '不能为空',
  'v.common.ga.setup': '执行此操作之前，您必须先设置谷歌身份验证',
  'v.common.mobile.required': common.plsEnter + '您的手机号',
  'v.common.mobile.format': '手机号码格式不正确',
  'v.common.newMobile.required': common.plsEnter + '新手机号',
  'v.common.newMobile.cannot.same': '新手机号与旧手机号不能一致',
  'v.common.setup.ga.before.trade': '请在交易之前设置谷歌身份验证',
  'v.common.setup.txnPwd.before.trade': '请在交易之前设置交易密码',
  'v.common.walletAddr.format': '请输入正确的地址',
  'v.common.session.timeout': '登入已超时',

  'v.trade.volume.required': common.plsEnter + '数量',
  'v.trade.price.required': common.plsEnter + '价格',
  'v.trade.price.min': '最低价格:{priceMin}',
  'v.trade.price.max': '最高价格:{priceMax}',
  'v.trade.amount.insufficientBalance': '余额不足',

  'success.copy': '复制成功',
  'success.resetPwd': '密码重置成功!',
  'success.withdraw': '提币成功',
  'success.withdraw.cancel': '提币已被撤销',
  'success.wallet.add': '地址添加成功',
  'success.wallet.delete': '地址删除成功',
  'success.ga.bind': '谷歌验证绑定成功',
  'success.ga.unbind': '谷歌验证解除绑定成功',
  'success.invite': '邀请码添加成功',
  'success.loginPwd': '登录密码设置成功',
  'success.loginPwd.modify': '登录密码修改成功',
  'success.phone.bind': '手机号码绑定成功',
  'success.phone.unbind': '手机号解除绑定成功',
  'success.order.place': '成功下单',
  'success.txnPwd.set': '交易密码设置成功！',
  'success.deleteMsg': '消息已成功删除',
  'success.bindMAXWallet': '绑定MAX-Wallet成功',
  'success.allOrderCancel': '批量撤销成功',
  'success.affiliateInvite': '您的申请已批准。',
  'success.partnerInvite': '您的申请已批准。',
  'success.partnerInvite2': '您已成功提交申请。',
  'success.verifyBtn': 'Sent verification code successfully',

  'teamProfile.title': '公司管理层',
  'teamProfile.person1': 'RYAN FELLAL',
  'teamProfile.person1.position': '首席执行官',
  'teamProfile.desc.1': `Ryan，金融衍生产品领域行业专家，精通于为超高净值人士（UHNWI）、企业及私人机构提供定制化风险管理和融资解决方案。起初，Ryan在著名的瑞士信贷集团（Credit Suisse，总部位于瑞士苏黎世）展开其衍生品领域职业生涯，随后成为申展（上海）商务信息咨询有限公司（知名的英国财富管理公司St. James’s Place Wealth Management位于上海的分支）副合伙人。`,
  'teamProfile.desc.2': `Ryan为人处事客观正直，擅长于多样化环境下的对外沟通与交流；同时，作为一名结果导向型的专业职场人士，Ryan以其为客户提供的优质服务而广受认可。此外，他还是一位“亚洲通”，经常因工作之契机前往多个亚洲和东南亚国家，因而对丰富多彩的东方文化和悠久的历史传统有着全面的了解和深深的敬意。`,
  'teamProfile.desc.3': `目前，Ryan以GRXTrade首席执行官的身份加入公司，为GRXTrade平台带来了其全方位的投资和金融服务咨询领域经验，必将带领企业及其产品进入一个全新的发展高度。`,
  'warning.exceededPrice': '您的价格超过当前价格(PERCENTAGE)',

  'dClub.title': 'DCLUB',
  'dClub.desc.1': 'GRXTrade offers you complimentary DCLUB learning opportunities.',
  'dClub.desc.2': 'Unable to download app? ',
  'dClub.step1': 'Open the DCLUB App',
  'dClub.step2': 'temporary',
  'dClub.step3': 'Point the camera at the QR code above',
  'dClub.step4': 'Point the camera at the QR code above',
  'dClub.hyperLink': 'Please try to <a style="color: #1E49AC;">Download iOS IPA</a> or <a style="color: #1E49AC;">Download Android APK</a>',

  'registerSuccessfulModel.title': 'Congratulation',
  'registerSuccessfulModel.desc': 'Your account has been successfully created! <div> We recommend you that to download our mobile app now! </div>',
  'registerSuccessfulModel.unableToDownloadDesc': 'Unable to download app? ',
  'registerSuccessfulModel.hyperLink': 'Please try to <a style="color: #1E49AC;">Download iOS IPA</a> or <a style="color: #1E49AC;">Download Android APK</a>',

  'downloadBox.title': 'GRXTrade 应用程序',

  'invitationPoster.registerNow':'立即注册',
};
